import { render } from "./ChangePassword.vue?vue&type=template&id=6a2d91fc&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=6a2d91fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a2d91fc"

export default script